<template>
  <button
    :style="backgroundImageStyle"
    :class="[getCss('border'), getCss('text'), {'csu-clickable': clickable}]"
    @click="jumpLinkHandler"
  >
    <span>{{ configurationData.btnText || '' }}</span>
  </button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common, baseComponents } from '@tencent/ceiba-base-components';
export default {
  name: 'CPublicGameJumpButton',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-game-jump-button-',
      gameActList: this.configurationData?.gameActList || [],
      currentGameStatusList: {},
    };
  },
  computed: {
    backgroundImageStyle() {
      const { isStretching, bgImage } = this.configurationData;
      return {
        ...this.styles.base,
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'transparent',
        backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
      };
    },
    defaultKeyArr() {
      return this.configurationData?.defaultKey?.split('|') ?? [];
    },
    defaultKeyValue() {
      const { defaultKeyValue = '' } = this.configurationData;
      if (typeof defaultKeyValue === 'string' && defaultKeyValue.length > 0) {
        const tempArray = defaultKeyValue.split('&').map(item => item.split('='));
        return Object.fromEntries(tempArray);
      }
      return {};
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      console.log('【public-game-jump-button】configurationData=', this.configurationData);
      this.$onLogined(() => {
        this.getGameOpenStatusList();
      });
    },
    // 获取跳转活动是否开放列表
    async getGameOpenStatusList() {
      if (this.configurationData.gameActStatusFlowId > 0) {
        const res = await this.flowRequest({
          flowId: this.configurationData.gameActStatusFlowId,
        });
        if (res.ret !== 0) {
          return;
        }
        const { data } = res;
        if (data?.ret !== 0 || Object.keys(data?.dataMap).length === 0) {
          return;
        }
        this.currentGameStatusList = data.dataMap;
      }
    },
    async jumpLinkHandler() {
      if (this.$isInEditor && !this.isInPreview) return;
      if (!this.isLogin) {
        baseComponents.userLoginComponent.login();
        return;
      }
      const nowShowGid = this.currentGid || '';

      if (Object.keys(this.currentGameStatusList).length === 0
        || this.gameActList.length === 0
        || !this.currentGameStatusList[nowShowGid]) {
        return this.alert(this.configurationData?.emptyActLinkText || '活动即将上线，敬请期待~');
      }
      const arr = this.gameActList.find(e => String(e?.gameGid) === String(nowShowGid));
      let url = arr?.actJumpLink || '';
      if (!url) {
        return this.alert(this.configurationData?.emptyActLinkText || '活动即将上线，敬请期待~');
      }
      // 截取一级域名
      const domain = url.split('//')[1]?.split('/')[0];
      //  tgclub://  协议的目标地址 不需要同步登录态
      if (url.indexOf('tgclub://') === -1) {
        await new Promise((resolve) => {
          try {
            this.$miloCore?.loginStatus?.syncToQQ(domain, {
              appid: common.tool.getCookie('appid') || '',
              openid: common.tool.getCookie('openid') || '',
              access_token: common.tool.getCookie('access_token') || '',
              acctype: common.tool.getCookie('acctype') || '',
            }, () => {
              console.log('sync login status');
              resolve();
            });
          } catch (err) {
            console.log('syncToQQ==', err);
          }
        });
      }

      if (this.defaultKeyArr.length > 0) {
        url = this.getInviteCodeFromUrl(this.defaultKeyArr, url);
        // console.log('【public-game-jump-button】url', url);
      }
      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      url = common.tool.passThroughUrlParam(url, ['via', 'trace_id', 'via_source']);
      // console.log('【public-game-jump-button】finalUrl===', url);
      window.location.href = url;
    },
    // 获取链接上的参数
    getInviteCodeFromUrl(arr, link) {
      let newLink = link;
      arr.forEach((v, i) => {
        // console.log('【public-game-jump-button】paramsStr.v=', v);
        let getVal = common.tool.getQueryParams(arr[i]) || '';
        if (getVal.length === 0) {
          getVal = this.defaultKeyValue[arr[i]] || '';
        }
        // console.log('【public-game-jump-button】paramsStr.getVal=', getVal);
        newLink = common.tool.setUrlParam(`${v}`, `${getVal}`, newLink);
      });
      return newLink;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
